import React from "react";
import { Helmet } from "react-helmet-async";
import AccountSetupLayout from "components/Accounts/Layouts/AccountSetupLayout";

const AuthRedirect = ({ siteName }) => (
  <div className="fixed inset-0 z-[10000000] bg-[#0c0f1e]">
    <AccountSetupLayout>
      <Helmet>
        <title>Redirecting...</title>
      </Helmet>
      <div className="text-white text-[30px] font-bold font-barlow mb-[16px]">Redirecting...</div>
      <div className="mb-[30px] text-lavender-50 text-[14px] font-inter">
        You're being redirected to <span style={{ fontWeight: 700, color: "white" }}>{siteName}</span>, it may take a few seconds.
      </div>
    </AccountSetupLayout>
  </div>
);

export default AuthRedirect;
